import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {userRegister} from "../../services/userRegister";

class LanguageButton extends Component {

    constructor(props) {
        super(props);
        this.state = {
            languages: [],
            lang: null
        };
    };

    componentWillMount() {
        this._updateLang();
        this._updateLanguages();
        this._updateUser();
    }

    _updateUser(){
        let user = userRegister.get();
        if(user){
            this.setState({
                reseller: user.reseller,
                inhouse: user.inhouse
            });
        }
        if (user.socialData) {
            this.setState({
                branding: user.socialData.branding ? user.socialData.branding : false
            });
        }
    }

    _updateLang(){
        this.setState({lang: langRegister.lang()});
    }

    _updateLanguages() {
        let languages = JSON.parse(salesChannelRegister.get('languages'));
        if(Array.isArray(languages)){
            this.setState({languages: languages});
        }
    }

    _setLang(prop){
        if(prop.toLowerCase() !== langRegister.lang().toLowerCase()){
            langRegister.set(prop);
            try{
                let splits = this.props.props.location.pathname.split('/');
                let lang = splits[2];
                let option = splits[4];
                let sub_option = splits[5];

                console.log(option, sub_option);

                if(sub_option){
                    this.props.props.history.replace("/" + salesChannelRegister.get('market') + "/" + prop +"/user/" + option + "/" + sub_option);
                }else{
                    this.props.props.history.replace("/" + salesChannelRegister.get('market')  + "/" + prop +"/user/" + option);
                }
            }catch (e) {
                this.props.props.history.replace("/" + salesChannelRegister.get('market')  + "/" + prop +"/user/campaigns/running");
            }
            window.location.reload();
        }else{
            this.setState({dropdown: false});
        }
    }

    render() {
        return (
            <div>
                {
                    this.state.dropdown &&
                    <div onClick={() => this.setState({dropdown: false})} className={Styles.languageButtonContainerOverlay}/>
                }
                <div className={Styles.languageButtonContainer}>
                    {
                        this.state.reseller && !this.state.inhouse &&
                        <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#E65032'}:{}} className={Styles.languageButtonVIP}>
                            VIP
                        </div>
                    }
                    {
                        this.state.inhouse && !this.state.branding &&
                        <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#E65032'}:{}} className={Styles.languageButtonVIP}>
                            INHOUSE
                        </div>
                    }
                    {
                        this.state.inhouse && this.state.branding &&
                        <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#E65032'}:{}} className={Styles.languageButtonVIP}>
                            ENTERPRISE
                        </div>
                    }
                    <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} onClick={() => this.setState({dropdown: !this.state.dropdown})} className={Styles.languageButton}>
                        {this.state.lang}
                    </div>
                    {
                        this.state.dropdown &&
                        <div>
                            <div className={Styles.languageButtonDropdown}>
                                {
                                    this.state.languages.map((item) => {
                                        return(
                                            <div onClick={() => this._setLang(item.code)} className={Styles.languageButtonDropdownItem}>
                                                {item.names[langRegister.lang()]}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className={Styles.languageButtonTriangle}/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default LanguageButton;


// WEBPACK FOOTER //
// ./src/components/language-button/component.js